import { ITranslationItems } from './language.types';

export const LABELS: ITranslationItems = {
  submit: {
    nl: 'Indienen',
    en: 'Submit',
  },
  cancel: {
    nl: 'Annuleren',
    en: 'Cancel',
  },
  again: {
    nl: 'Probeer opnieuw',
    en: 'Try again',
  },
  close: {
    nl: 'Sluit formulier',
    en: 'Close form',
  },
  back: {
    nl: 'Terug',
    en: 'Back',
  },
};

export const TITLES: ITranslationItems = {
  success: {
    nl: 'Je aanvraag is voltooid',
    en: 'Your request has been completed',
  },
};

export const labelHelper = (pageName: string) => {
  return {
    back: {
      nl: `Terug naar ${pageName}`,
      en: `Return to ${pageName}`,
    },
  };
};
